export default __webpack_public_path__ + "static/media/side-right-login.4bded631.svg";